import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import useFetch from 'hooks/useFetch';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import EditIcon from '@mui/icons-material/Edit';
import CreateNewModal from './CreateNewModal';

const Agents = () => {
    const { data, isLoading, refetch } = useFetch('/api/maintenance/agents/');
    const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });
    const [selectedAgent, setSelectedAgent] = useState(null);

    useEffect(() => {
        if(data){
            const renderCell = ({ value }) => <DefaultCell value={value} />;

            const columns = [
                { Header: 'Id', accessor: 'id_agente', Cell: renderCell },
                { Header: 'Nombre', accessor: 'nombre', Cell: renderCell },
                { Header: 'Pais', accessor: 'pais', Cell: renderCell },
                { Header: 'Dirección', accessor: 'direccion', Cell: renderCell },
                { Header: 'Acciones', accessor: 'acciones', Cell: renderCell },
            ];

            const rows = data.map((agent) => ({
                id_agente: agent.id_agente,
                nombre: agent.nombre,
                pais: agent.pais || 'N/A',
                direccion: agent.direccion || 'N/A',
                acciones: (
                    <DataTableDocumentActions
                        actions={[{
                            Icon: EditIcon,
                            onClick: () => handleEdit(agent),
                            color: 'primary'
                        }]}
                    />
                )
            }));

            setDataTableData({ columns, rows });
        }
    }, [data]);

    const handleEdit = (document) => {
        setSelectedAgent(document);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <DataTableHeaderOptions
                createNewTitle='Nuevo Agente'
                dataTableData={dataTableData}
                hasFilters={false}
                setSelectedDocument={setSelectedAgent}
                selectedDocument={selectedAgent}
                getData={refetch}
                CreateNewModal={CreateNewModal}
            />
            <Card>
                {isLoading ? (
                    <DataTableLoader />
                ) : (
                    <DataTable
                        table={dataTableData}
                        entriesPerPage={true}
                        canSearch={true}
                        showTotalEntries={true}
                    />  
                )}
            </Card>
            <Footer />
        </DashboardLayout>
    );
}

export default Agents;
